/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ReviewRouteImport } from './routes/review'
import { Route as ExtractRouteImport } from './routes/extract'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthSpotifyRouteImport } from './routes/auth/spotify'

const ReviewRoute = ReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => rootRouteImport,
} as any)
const ExtractRoute = ExtractRouteImport.update({
  id: '/extract',
  path: '/extract',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSpotifyRoute = AuthSpotifyRouteImport.update({
  id: '/auth/spotify',
  path: '/auth/spotify',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/extract': typeof ExtractRoute
  '/review': typeof ReviewRoute
  '/auth/spotify': typeof AuthSpotifyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/extract': typeof ExtractRoute
  '/review': typeof ReviewRoute
  '/auth/spotify': typeof AuthSpotifyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/extract': typeof ExtractRoute
  '/review': typeof ReviewRoute
  '/auth/spotify': typeof AuthSpotifyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/extract' | '/review' | '/auth/spotify'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/extract' | '/review' | '/auth/spotify'
  id: '__root__' | '/' | '/extract' | '/review' | '/auth/spotify'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ExtractRoute: typeof ExtractRoute
  ReviewRoute: typeof ReviewRoute
  AuthSpotifyRoute: typeof AuthSpotifyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/review': {
      id: '/review'
      path: '/review'
      fullPath: '/review'
      preLoaderRoute: typeof ReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/extract': {
      id: '/extract'
      path: '/extract'
      fullPath: '/extract'
      preLoaderRoute: typeof ExtractRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/spotify': {
      id: '/auth/spotify'
      path: '/auth/spotify'
      fullPath: '/auth/spotify'
      preLoaderRoute: typeof AuthSpotifyRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ExtractRoute: ExtractRoute,
  ReviewRoute: ReviewRoute,
  AuthSpotifyRoute: AuthSpotifyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
